export class Token {
    tokenId: number;
    userId: number;
    token: string;
    role: string;
  }